<div class="p-10">
  <router-outlet></router-outlet>
</div>
